import React from 'react';
import { Grid, Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import logo from '../../../assets/Logo.svg';
import darkLogo from '../../../assets/DarkLogo.svg';
import { getHeaderStyles } from './Header.styles';
import { navRoutes } from '../../../constants/navRoutes';
import NavigateButton from '../../../components/NavigateButton/NavigateButton';
import MobileHeader from './MobileHeader/MobileHeader';

const Header = ({ isSecondary = false, secondaryButton = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const styles = getHeaderStyles(isSecondary);
  const linkColor = isSecondary ? 'secondary' : 'primary';

  if (isMobile) {
    return <MobileHeader isSecondary={isSecondary} />;
  }

  const isActiveRoute = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Grid container sx={styles.container}>
      {/* First Column: Logo + Navigation Links */}
      <Grid size={{ xs: 12, md: 7 }} sx={styles.firstColumn}>
        <Box>
<img
            src={isSecondary ? logo : darkLogo}
            alt="Royal Vista Logo"
            fetchPriority="high"
            style={styles.logo}
          />
        </Box>
        <Box sx={styles.navLinksContainer}>
          {navRoutes.map((route) => (
            <Button
              key={route.path}
              component={RouterLink}
              to={route.path}
              color={linkColor}
              sx={{
                ...styles.navLink,
                ...(isActiveRoute(route.path) && styles.navLinkActive),
              }}
            >
              {route.label}
            </Button>
          ))}
        </Box>
      </Grid>

      {/* Second Column: Action Buttons */}
      <Grid size={{ xs: 12, md: 5 }} sx={styles.secondColumn}>
        <Button
          variant="outlined"
          sx={secondaryButton ? styles.secondaryButton : styles.signInButton}
          onClick={() => window.open('https://royalvista.guestyowners.com/login', '_blank')}
        >
          Owner Login
        </Button>

        <NavigateButton
          title="Book Your Stay"
          isSecondary={isSecondary}
          onClick={() => window.open('https://royal-vista.guestybookings.com/en/properties', '_blank')}
        />
      </Grid>
    </Grid>
  );
};

export default Header;

